import { css } from 'emotion';
import { components, colors, fonts } from '@peachjar/components';

const { Container, Buttons } = components;
const { slate } = colors;
const { ProximaNova, ProximaNovaSemiBold } = fonts;

const styles = {
  container: css`
    background-color: white;
    padding: 4rem 3rem !important;
    border-radius: 3px;
  `,
  numberedRowWrapper: css`
    margin-top: 12px;
    & > * {
      margin-bottom: 57px;
    }
  `,
  placeholderText: css`
    color: ${slate};
  `,
};

export default styles;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/containers/SetupOrganizationContainer.css.js